
  import { defineComponent, PropType } from 'vue';

  import ContextMenu from '@/common/components/redesigned/ContextMenu/ContextMenu.vue';
  import ContextMenuItem from '@/common/components/redesigned/ContextMenu/ContextMenuItem.vue';

  import { GlobalContextMenuActions, TAdditionalMenuConfig } from './types';

  export default defineComponent({
    name: 'GlobalContextMenu',
    components: {
      ContextMenu,
      ContextMenuItem,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      isFlatTree: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object as () => { top: number; left: number },
        required: true,
      },
      additionalMenu: {
        type: Array as PropType<TAdditionalMenuConfig[]>,
        default: () => [],
      },
      isSingleMode: {
        type: Boolean,
        required: true,
      },
    },
    emits: ['action', 'close'],
    methods: {
      handleClose() {
        this.$emit('close');
      },

      handleSelectAll() {
        this.handleAction(GlobalContextMenuActions.SELECT_ALL);
      },

      handleUnselectAll() {
        this.handleAction(GlobalContextMenuActions.UNSELECT_ALL);
      },

      handleExpandAll() {
        this.handleAction(GlobalContextMenuActions.EXPAND_ALL);
      },

      handleCollapseAll() {
        this.handleAction(GlobalContextMenuActions.COLLAPSE_ALL);
      },

      handleAction(action: GlobalContextMenuActions) {
        this.$emit('action', action);
        this.$emit('close');
      },
    },
  });
